module.exports = __webpack_public_path__ + "static/media/20_2.2a2337cd.png";